class Mensagem{
    constructor(){
        
    }
}

export default Mensagem
